import {enConfig} from './en';

export const esConfig = {
    ...enConfig.base,
    bismi:'En el nombre de Dios, el Compasivo, el Misericordioso.',
    salaam:'Salaam',
    header:{
        signup : "Inscripción para una mejor salud",
        signin : "Conexión",    
        signout : "Salida",
        close: "Cerrar",
        profile: "Perfil",
    },
    
    home:{
        title : 'Digitalización',
        article : 'Artículos',
        contact : 'Contacto',
        about: 'Acerca de',
        connected: 'Debe estar registrado'
    },

    blog: {
        ...enConfig.blog,
        title :'Artículos más interesantes',
    },

    about:{
        title:'Más saludable',
        content:'Usar tecnología e IA para hacer que las personas sean más saludables',
    },

    contact:{
        title:'Contáctenos',
        message:'Complete el siguiente formulario para enviarnos un correo electrónico',
        confirm:'Confirmación de contacto',
        content:'Complete el código que le enviamos por correo electrónico para confirmarlo',
        recipient:"Confirme la información del destinatario.",
        feedback : 'Hemos recibido su mensaje, nos pondremos en contacto con usted lo antes posible',
        warning : "Necesita confirmar su correo electrónico antes de continuar"
    },

    getApp : {
        name : 'Descargar Services App',
        info : 'Descargar Services App',
        label : 'Descargar Services App',
    },

}
